import { Reveal, MaskReveal } from "@/components/site/Reveal";

export const PageHeader = ({ index, eyebrow, title, effective, intro }) => (
  <header className="relative overflow-hidden border-b border-line bg-paper-2">
    <div
      aria-hidden="true"
      className="checker pointer-events-none absolute -right-16 -top-20 h-64 w-64 rounded-3xl opacity-40 sm:h-80 sm:w-80"
    />
    <div className="container-x relative py-20 sm:py-28">
      {index && (
        <Reveal>
          <span className="font-mono text-sm text-brand">{index}</span>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <span className="eyebrow mt-4">{eyebrow}</span>
      </Reveal>
      <h1 className="mt-5 font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-ink sm:text-5xl lg:text-6xl">
        <MaskReveal lines={[title]} delay={0.1} />
      </h1>
      {effective && (
        <Reveal delay={0.2}>
          <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-line bg-paper px-4 py-2 font-mono text-xs uppercase tracking-[0.16em] text-ink-soft">
            Effective Date: {effective}
          </p>
        </Reveal>
      )}
      {intro && (
        <Reveal delay={0.25}>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-soft">{intro}</p>
        </Reveal>
      )}
    </div>
  </header>
);

export const Prose = ({ children }) => (
  <div className="container-x max-w-3xl py-16 sm:py-20">
    <div className="space-y-5 text-base leading-[1.75] text-ink-soft [&_h2]:mt-12 [&_h2]:text-ink [&_strong]:text-ink">
      {children}
    </div>
  </div>
);
